import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import useSWR from 'swr';

import CpdCourseTsiStyle from './style';

import CoursesCard from '@components/molecules/courseCard';
import HeadingCpdCourse from '@components/molecules/heading/cpdCourse';
import { CPD_END_POINT } from 'src/api/cpd';
import config from 'src/config';
import { RegulatorType } from 'src/helpers/constants';
import { IBreadcrumb, ICourse } from 'src/interfaces';
import { CPDProduct } from 'src/types/product';

const CpdCourseTsi = () => {
  const { t } = useTranslation('common');
  const { data: products } = useSWR<CPDProduct>(CPD_END_POINT.COURSES);
  const breadcrumbList = () => {
    const breadcrumbs: IBreadcrumb[] = [
      { description: t('cpd_course.all_training_course'), url: '/cpd' },
      {
        description: t('cpd.tsi.applicant_type'),
      },
    ];
    return breadcrumbs;
  };

  return (
    <CpdCourseTsiStyle>
      <HeadingCpdCourse
        contentHeight="200px"
        breadcrumbList={breadcrumbList()}
        headerTitle={t('cpd.tsi_title')}
        headerDesc={t('cpd.tsi.applicant_type')}
        backgroundImage={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/Banner-OIC-NONLIFE.png`}
      />
      <Box className="container">
        <Typography variant="h1" color="#174944" className="topic" style={{ marginBottom: '15px' }}>
          {t('cpd.common.course')}
          {t('cpd.tsi.applicant_type')}
        </Typography>

        <Typography variant="h3" color="#174944" className="section-text">
          {t('cpd.common.course')}
        </Typography>
        <Box sx={{ mt: { lg: 4, xs: 2 } }}>
          <CoursesCard courses={products?.courses} />
        </Box>
        {products?.bundles && products?.bundles.length > 0 && (
          <>
            <Typography variant="h3" color="#174944" className="section-text">
              {t('cpd.common.bundle')}
            </Typography>
            <Box sx={{ mt: { lg: 4, xs: 2 } }}>
              <CoursesCard courses={products?.bundles} />
            </Box>
          </>
        )}
      </Box>
    </CpdCourseTsiStyle>
  );
};

export default CpdCourseTsi;
